import {
  CcfBox,
  CcfNoRequestFoundIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { CcfWemTable } from './ccf-wem-table';

/* eslint-disable-next-line */
export interface CcfWemShiftBiddingProps {}

/**
 * CcfWemShiftBidding - used to display wem schedule requests
 * @param props - CcfWemShiftBidding
 * @example `<CcfWemShiftBidding />`
 */
export function CcfWemShiftBidding(props: CcfWemShiftBiddingProps) {
  const columns = [
    {
      field: 'biddingDateRange',
      headerName: 'BIDDING DATE RANGE',
      minWidth: 300,
      flex: 1,
    },
    {
      field: 'createdBy',
      headerName: 'INITIATED BY',
      minWidth: 300,
      flex: 1,
    },

    {
      field: 'status',
      headerName: 'STATUS',
      minWidth: 150,
      renderCell: (params: any) => (
        <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {params.row.status === 'Bid Open' ? (
            <img
              src="./assets/BidIcon.png"
              alt="BidIcon"
              style={{ width: '16px' }}
            />
          ) : (
            <img
              src="./assets/deleteIcon.png"
              alt="canceledIcon"
              style={{ width: '16px' }}
            />
          )}
          {params.value}
        </CcfBox>
      ),
    },
    {
      field: 'bidSubmitted',
      headerName: 'BID SUBMITTED',
      minWidth: 250,
    },
  ];

  /**@example */
  function getDateRange() {
    const today: Date = new Date();
    const pastDate: Date = new Date();
    pastDate.setDate(today.getDate() + 12);

    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    };

    const formattedPastDate: string = pastDate.toLocaleDateString(
      'en-US',
      options
    );
    const formattedToday: string = today.toLocaleDateString('en-US', options);

    return `${formattedToday} - ${formattedPastDate}`;
  }

  /**@example */
  function getPastDateRange() {
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    };

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const twelveDaysBefore = new Date();
    twelveDaysBefore.setDate(yesterday.getDate() - 12);

    const formattedYesterday: string = yesterday.toLocaleDateString(
      'en-US',
      options
    );
    const formattedTwelveDaysBefore: string =
      twelveDaysBefore.toLocaleDateString('en-US', options);

    return `${formattedTwelveDaysBefore} - ${formattedYesterday}`;
  }
  const rowData = [
    {
      id: '0',
      status: 'Bid Open',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '1',
      status: 'Bid Open',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '2',
      status: 'Canceled',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '3',
      status: 'Canceled',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '4',
      status: 'Bid Open',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '5',
      status: 'Bid Open',
      biddingDateRange: getDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '6',
      status: 'Canceled',
      biddingDateRange: getPastDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '7',
      status: 'Bid Open',
      biddingDateRange: getPastDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '8',
      status: 'Bid Open',
      biddingDateRange: getPastDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
    {
      id: '9',
      status: 'Canceled',
      biddingDateRange: getPastDateRange(),
      createdBy: 'Administrator01 Perm_TestGBU',
      bidSubmitted: '',
    },
  ];
  /**
   *
   * @example - noDataFound()
   */
  const noBidsFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfNoRequestFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noRequestTxt}>
            No bids were generated yet
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Shift Bidding
        </CcfTypography>
      </CcfBox>
      <CcfWemTable
        rowData={rowData}
        columns={columns}
        noDataFound={noBidsFound()}
        tableHeaderText={`${rowData.length} bids`}
        isSelectRequired={false}
      />
    </CcfBox>
  );
}
